module.exports = __webpack_public_path__ + "img/mlEstimationMethod.f7e42e62.png";